import { rem, spacing, token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../../helpers/element.helper';

export const tag = tagName('tree-item');

export const styles = [
  css`
    :host {
      display: block;

      --hover-color: ${token('background-tertiary')};
      --background-color: transparent;
    }

    :host(:focus),
    :host(:focus-within) {
      outline: none;
    }

    .tree-item {
      align-items: stretch;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      position: relative;
      user-select: none;
    }

    .tree-item__checkbox {
      align-self: flex-start;
      padding-block-start: ${spacing(50)};
      pointer-events: none;
    }

    .tree-item__indentation {
      display: block;
      flex-shrink: 0;
      inline-size: 1em;
    }

    .tree-item__item {
      align-items: center;
      border-inline-start: solid ${rem(2)} transparent;
      display: flex;
      gap: ${spacing(100)};

      &:hover {
        background-color: var(--hover-color, transparent);

        .tree-item__expand-button--visible {
          background: var(--background-color, transparent);

          &:hover {
            background: var(--hover-color, ${token('background-tertiary')});
            color: ${token('text-link-active')};
          }
        }

        &:has(.tree-item__expand-button--visible:hover) {
          background: var(--background-color, transparent);
        }
      }
    }

    :host(:focus-visible) .tree-item__item {
      outline-color: var(--tm-focus-ring-color);
      outline-offset: calc(-1 * var(--tm-focus-ring-width));
      outline-style: var(--tm-focus-ring-style);
      outline-width: var(--tm-focus-ring-width);
      z-index: 2;
    }

    :host(:not([aria-disabled='true']))
      .tree-item--selected
      .tree-item__item:not(:has(a-checkbox)) {
      background-color: ${token('tree-item-background-selected')};
      border-inline-start-color: ${token('border-interactive')};
    }

    .tree-item__label,
    .tree-item__checkbox,
    .tree-item__expand-button {
      font-size: 1rem;
    }

    .tree-item__label {
      align-items: center;
      display: flex;
    }

    .tree-item__expand-button {
      align-items: center;
      block-size: 1rem;
      color: ${token('foreground-interactive')};
      display: flex;
      flex-shrink: 0;
      margin-inline-start: auto;
      padding: ${spacing(100)};
    }

    .tree-item--expanded a-icon[name='chevron-down'],
    .tree-item:not(.tree-item--expanded) a-icon[name='chevron-up'] {
      display: none;
    }

    .tree-item:not(.tree-item--has-expand-button) a-icon {
      display: none;
    }

    .tree-item__children {
      display: block;
      font-size: calc(1em + var(--indent-size, 1rem));
      position: relative;
    }

    .tree-item:not(.tree-item--expanded) .tree-item__children {
      display: none;
    }
  `,
];
